export const API_BASE_URL = process.env.REACT_APP_API_URL
export const CUSTOMER_SITE_URL = process.env.REACT_APP_CUSTOMER_URL

// Auth
export const ApiLogin = {
	method: 'post',
	url: '/api/Auth/Login'
}
export const ApiCheckAuth = {
	method: 'post',
	url: 'api/Auth/CheckAuth'
}
export const ApiRegister = {
	method: 'post',
	url: 'api/Auth/Register'
}

// Brand
export const ApiGetBrandList = {
	method: 'post',
	url: '/api/Brand/GetList'
}
export const ApiGetBrandById = {
	method: 'post',
	url: 'api/Brand/GetById'
}
export const ApiCreateBrand = {
	method: 'post',
	url: 'api/Brand/Create'
}
export const ApiDeleteBrand = {
	method: 'post',
	url: 'api/Brand/Delete'
}

// Product
export const ApiGetProductList = {
	method: 'post',
	url: '/api/Product/GetList'
}
export const ApiGetProductById = {
	method: 'post',
	url: 'api/Product/GetById'
}
export const ApiCreateProduct = {
	method: 'post',
	url: 'api/Product/Create'
}
export const ApiUpdateProduct = {
	method: 'post',
	url: 'api/Product/Update'
}
export const ApiDeleteProduct = {
	method: 'post',
	url: 'api/Product/Delete'
}

// Category
export const ApiGetCategoryList = {
	method: 'post',
	url: '/api/Category/GetList'
}
export const ApiGetCategoryById = {
	method: 'post',
	url: 'api/Category/GetById'
}
export const ApiCreateCategory = {
	method: 'post',
	url: 'api/Category/Create'
}
export const ApiUpdateCategory = {
	method: 'post',
	url: 'api/Category/Update'
}
export const ApiDeleteCategory = {
	method: 'post',
	url: 'api/Category/Delete'
}

// Customer
export const ApiGetCustomerList = {
	method: 'post',
	url: '/api/Customer/GetList'
}
export const ApiGetCustomerById = {
	method: 'post',
	url: 'api/Customer/GetById'
}
export const ApiCreateCustomer = {
	method: 'post',
	url: 'api/Customer/Create'
}
export const ApiUpdateCustomer = {
	method: 'post',
	url: 'api/Customer/Update'
}
export const ApiDeleteCustomer = {
	method: 'post',
	url: 'api/Customer/Delete'
}

// Sales Stock
export const ApiGetSalesStockList = {
	method: 'post',
	url: '/api/SalesStock/GetList'
}
export const ApiGetSalesStockById = {
	method: 'post',
	url: 'api/SalesStock/GetById'
}
export const ApiCreateSalesStock = {
	method: 'post',
	url: 'api/SalesStock/Create'
}
export const ApiUpdateSalesStock = {
	method: 'post',
	url: 'api/SalesStock/Update'
}
export const ApiDeleteSalesStock = {
	method: 'post',
	url: 'api/SalesStock/Delete'
}

// Rental Stock
export const ApiGetRentalStockList = {
	method: 'post',
	url: '/api/RentalStock/GetList'
}
export const ApiGetRentalStockById = {
	method: 'post',
	url: 'api/RentalStock/GetById'
}
export const ApiCreateRentalStock = {
	method: 'post',
	url: 'api/RentalStock/Create'
}
export const ApiUpdateRentalStock = {
	method: 'post',
	url: 'api/RentalStock/Update'
}
export const ApiDeleteRentalStock = {
	method: 'post',
	url: 'api/RentalStock/Delete'
}
export const ApiGetRentalStockPrice = {
	method: 'post',
	url: 'api/RentalStock/GetRentalStockPrice'
}

// Order Sales Transaction
export const ApiGetOrderSalesStockList = {
	method: 'post',
	url: '/api/OrderSales/GetStockList'
}
export const ApiCreateSalesOrder = {
	method: 'post',
	url: '/api/OrderSales/Create'
}
export const ApiGetOrderSalesById = {
	method: 'post',
	url: '/api/OrderSales/GetById'
}

// Order Rental Transaction
export const ApiGetOrderRentalStockList = {
	method: 'post',
	url: '/api/OrderRental/GetStockList'
}
export const ApiCreateOrderRental = {
	method: 'post',
	url: '/api/OrderRental/Create'
}
export const ApiGetOrderRentalList = {
	method: 'post',
	url: '/api/OrderRental/GetList'
}
export const ApiGetOrderRentalById = {
	method: 'post',
	url: '/api/OrderRental/GetById'
}
export const ApiOrderRentalDelivered = {
	method: 'post',
	url: '/api/OrderRental/Delivered'
}
export const ApiOrderRentalReturned = {
	method: 'post',
	url: '/api/OrderRental/RentalReturned'
}

// Transaction
export const ApiGetOrderList = {
	method: 'post',
	url: '/api/OrderSales/GetList'
}

// System
export const ApiGetSystem = {
	method: 'post',
	url: '/api/System/GetSystem'
}
export const ApiUpdateSystem = {
	method: 'post',
	url: '/api/System/Update'
}

// Dashboard
export const ApiGetDashboardList = {
	method: 'post',
	url: 'api/Dashboard/GetList'
}

export const ApiGetDashboardHeader = {
	method: 'post',
	url: 'api/Dashboard/GetDashboardHeader'
}


// Old File
// Location
export const ApiGetLocationList = {
	method: 'post',
	url: 'api/Location/GetList'
}
export const ApiGetLocationById = {
	method: 'post',
	url: 'api/Location/GetById'
}
export const ApiInsertLocation = {
	method: 'post',
	url: 'api/Location/Create'
}
export const ApiUpdateLocation = {
	method: 'post',
	url: 'api/Location/Update'
}
export const ApiDeleteLocation = {
	method: 'post',
	url: 'api/Location/Delete'
}

// User
export const ApiUpdateUser = {
	method: 'post',
	url: 'api/User/Update'
}
export const ApiGetUserList = {
	method: 'post',
	url: 'api/User/GetList'
}
export const ApiGetUserById = {
	method: 'post',
	url: 'api/User/GetById'
}
export const ApiDeleteUser = {
	method: 'post',
	url: 'api/User/Delete'
}
export const ApiCheckIsAdmin = {
	method: 'post',
	url: 'api/User/CheckIsAdmin'
}
export const ApiGetCompanyAccessDropdown = {
	method: 'post',
	url: 'api/Company/Dropdown'
}



// User Access
export const ApiGetUserAccessList = {
	method: 'post',
	url: 'api/UserAccess/GetUserAccessList'
}
export const ApiGetUserMenuAccess = {
	method: 'post',
	url: 'api/UserAccess/GetUserAccessByUserId'
}
export const ApiCheckUserMenuAccess = {
	method: 'post',
	url: 'api/UserAccess/CheckAccess'
}






